export const PATIENT_BALANCE_OPTIONS = {
  BALANCE_TOTAL: "Patient.Balance.Total",
  BALANCE_PAYMENT_SOURCE: "Patient.PaymentSource",
  BALANCE_MANAGED_CARE_PLAN: "Patient.ManagedCarePlan",
  BALANCE_MANAGED_CARE_RESPONSIBILITY:
    "Patient.Balance.ManagedCareResponsibility",
  BALANCE_PATIENT_RESPONSIBILITY: "Patient.Balance.PatientResponsibility",
  BALANCE_INSURER_RESPONSIBILITY: "Patient.Balance.InsurerResponsibility",
  BALANCE_INSURANCE_POLICY: "Patient.Balance.Insurance Policy",
};

export const PATIENT_BALANCE_MENU_OPTIONS = {
  title: "Patient - Balance",
  menu: [
    {
      title: "Patient - Total Balance",
      value: PATIENT_BALANCE_OPTIONS.BALANCE_TOTAL,
    },
    {
      title: "Patient - Payment Source",
      value: PATIENT_BALANCE_OPTIONS.BALANCE_PAYMENT_SOURCE,
    },
    {
      title: "Patient - Managed Care Plan",
      value: PATIENT_BALANCE_OPTIONS.BALANCE_MANAGED_CARE_PLAN,
    },
    {
      title: "Patient - Managed Care Responsibility Balance",
      value: PATIENT_BALANCE_OPTIONS.BALANCE_MANAGED_CARE_RESPONSIBILITY,
    },
    {
      title: "Patient - Responsibility Balance",
      value: PATIENT_BALANCE_OPTIONS.BALANCE_PATIENT_RESPONSIBILITY,
    },
    {
      title: "Patient - Insurer Balance",
      value: PATIENT_BALANCE_OPTIONS.BALANCE_INSURER_RESPONSIBILITY,
    },
    {
      title: "Patient - Insurance Policy",
      value: PATIENT_BALANCE_OPTIONS.BALANCE_INSURANCE_POLICY,
    },
  ],
};
